import React from 'react';
import Form from "../Common/Form";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import joi from "joi";
import "./recruitForm.css";
import Swal from 'sweetalert2';

const captchaReference = React.createRef();

class RecruitForm extends Form {
    //State where errors and form data is stored
    state = {
        data: {
            nameKanji: "",
            nameKana: "",
            phoneNumber: "",
            email: "",
            address: "",
            classification: "社員募集(新卒採用)",
            gender: "男性",
            dob: "",
            lastEducation: "",
            desiredOccupation: "",
            reason: "",
            purpose: "",
            request: "",
            self_pr: "",
            captchaToken: ""
        },
        errors: {},
        displayMessage: false,
        userVerified: false,
    }

    //This is part of the EMAILJS 
    // componentDidMount() {
    //     init("user_CG9Vwt57oioQttfg33WwV");
    // }

    //Schema of validation
    schema = joi.object({
        nameKanji: joi.string()
            .empty()
            .regex(/^[^0-9|０-９]+$/)
            .messages({
                'string.pattern.base': "数字は許されません。",
                'string.empty': "入力必須な項目です。"
            }),
        nameKana: joi.string()
            .empty()
            .regex(/^[^0-9|０-９]+$/)
            .messages({
                'string.pattern.base': "数字は許されません。",
                'string.empty': "入力必須な項目です。"
            }),
        phoneNumber: joi.string()
            .empty()
            .regex(/^[0-9-]{10,13}$/i)
            //.regex(/^(?:\d{10}|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/)　//06-6347-5575
            .messages({
                'string.pattern.base': "半角数字で入力ください",
                'string.empty': "入力必須な項目です。"
            }),
        email: joi.string()
            .email({ tlds: { allow: false } })
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。",
                'string.email': '入力されたメールアドレスに間違いがあります。'
            }),
        address: joi.string()
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。"
            }),
        dob: joi.string()
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。"
            }),
        lastEducation: joi.string().allow(null, '').optional(),
        desiredOccupation: joi.string()
            .empty()
            .messages({
                "string.empty": "入力必須な項目です。"
            }),
        reason: joi.string()
            .empty()
            .messages({
                "string.empty": "入力必須な項目です。"
            }),
        gender: joi.string()
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。"
            }),
        classification: joi.string()
            .empty()
            .messages({
                "string.empty": "入力必須な項目です。"
            }),
        purpose: joi.string().allow(null, '').optional(),
        request: joi.string().allow(null, '').optional(),
        self_pr: joi.string().allow(null, '').optional(),
        captchaToken: joi.string().empty().messages({
            "string.empty": "Captchaを確認してください。"
        }),

    })

    // Contact type options for radio
    genderOptions = [
        {

            id: 1,
            optionName: "男性"
        },
        {
            id: 2,
            optionName: "女性"
        }
    ]

    //classification Options for radio
    classificationOptions = [
        {
            id: 3,
            optionName: "社員募集(新卒採用)",
        },
        {
            id: 4,
            optionName: "社員募集(中途採用)",
        }
    ]

    //This method will handle the sending of email
    //Before this method can run, there is validation method from the Parent Class
    doSubmit = async () => {
        //BlankState or Former State (元の状態)
        const blankState = {
            nameKanji: "",
            nameKana: "",
            phoneNumber: "",
            email: "",
            address: "",
            classification: "社員募集(新卒採用)",
            gender: "男性",
            dob: "",
            lastEducation: "",
            desiredOccupation: "",
            reason: "",
            purpose: "",
            request: "",
            self_pr: ""
        }

        const formData = new FormData();
        let data = { ...this.state.data };
        Object.keys(data).map(function (key) {
            formData.append(key, data[key])
            return null;
        })
        //Sweet alert loading
        Swal.fire({
            title: "読み込み中",
            didOpen: function () {
                Swal.showLoading()
            }
        })
        await fetch(this.emailEndPoint, {
            method: "POST",
            body: formData
        }).then(function (response) {
            //404
            if (!response.ok) {
                Swal.fire({
                    title: "エラー！",
                    text: "エラーが発生しました。後でもう一度お試しください。",
                    icon: "error",
                    confirmButtonText: "OK"
                })
                return false;
            }
            //Sweet alert Success
            Swal.fire({
                title: "成功！",
                text: "メールが送信されました。",
                icon: "success",
                confirmButtonText: "OK"
            })
        }).catch(function () {
            Swal.fire({
                title: "エラー！",
                text: "エラーが発生しました。後でもう一度お試しください。",
                icon: "error",
                confirmButtonText: "OK"
            })
        });
        //after alert, delete data to reset form
        this.setState({ data: blankState, userVerified: false });
        //reset captcha
        captchaReference.current.reset();

    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>採用情報 | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className="container-box banner-container" id="recruitForm-banner-container">
                    <div className="overlay"></div>
                    <div className="row">
                        <div className="col">
                            <h1>採用情報</h1>
                            <h3>RECRUITMENT</h3>
                        </div>
                    </div>
                </div>
                <div className="contact_container mt-5 pb-5">
                    <div className="row">
                        <div className="col ">
                            <p className="card-text">弊社へのお問合せ・ご質問等はこちらより承ります。<br />
                                下記の必要事項を入力のうえ、「確認する」ボタンを押し、送信ください。</p>
                            <form className="recruit-form" method="GET">
                                {/* <div className="row row-title mb-3">
                                  <div className="col col-hr"><hr /></div>
                                  <div className="col-10 col-sm-8 col-lg-6 col-xl-4">
                                      <h2 className="text-orange">応募種別</h2>
                                  </div>
                                  <div className="col col-hr"><hr /></div>
                              </div> */}
                                {this.renderInputRadio("classification", "職業", this.classificationOptions, this.classificationOptions[0])}
                                <div className="row row-title mb-3 mt-1">
                                    <div className="col col-hr"><hr /></div>
                                    <div className="col-10 col-sm-8 col-lg-6 col-xl-4">
                                        <h2 className="text-orange">プロフィール</h2>
                                    </div>
                                    <div className="col col-hr"><hr /></div>
                                </div>
                                {this.renderInputText("nameKanji", "お名前（氏名）")}
                                {this.renderInputText("nameKana", "お名前（カナ）")}
                                {this.renderInputText("phoneNumber", "電話番号")}
                                {this.renderInputText("email", "メールアドレス", "※携帯・PCどちらでも可", true, "email")}
                                {this.renderInputRadio("gender", "男性", this.genderOptions, this.genderOptions[0])}
                                {this.renderInputText("dob", "生年月日", "", true, "date")}
                                {this.renderInputText("address", "現住所")}
                                {this.renderInputText("lastEducation", "最終学歴", "", false)}
                                <div className="row row-title mb-5 mt-5">
                                    <div className="col col-hr"><hr /></div>
                                    <div className="col-10 col-sm-8 col-lg-6 col-xl-4">
                                        <h2 className="text-orange">エントリー内容</h2>
                                    </div>
                                    <div className="col col-hr"><hr /></div>
                                </div>
                                <div className="row mb-5">
                                    <span>１. 採用ご希望の職種をお教えください</span>
                                    {this.renderInputTextArea("desiredOccupation", "希望職種", "", "200px")}
                                </div>
                                <div className="row mb-5">
                                    <span> ２. 弊社への入社を希望される理由をお聞かせください </span>
                                    {this.renderInputTextArea("reason", "志望動機", "", "200px")}
                                </div>
                                <div className="row mb-5">
                                    <span>３. NAL入社後にどのようなことをしたいですか？</span>
                                    {this.renderInputTextArea("purpose", "入社の目的", "", "200px", false)}
                                </div>
                                <div className="row mb-5">
                                    <span>４. 会社に対して何を求めますか？</span>
                                    {this.renderInputTextArea("request", "NALへの要望", "", "200px", false)}
                                </div>
                                <div className="row mb-3">
                                    <span>５. あなたの「強み」をお聞かせください</span>
                                    {this.renderInputTextArea("self_pr", "自己PR", "", "200px", false)}
                                </div>
                                {this.renderCaptcha(captchaReference, "row mb-1")}
                                <ul className="mt-3 recruit-form-privacy-content ">
                                    <li>・
                                        <Link to="/privacy-policy" className="link-no-line"> [個人情報保護方針] </Link>
                                        をお読みいただき、同意いただける場合は「確認する」ボタンを押してください。</li>
                                    <li>・ 内容によっては回答を差し上げるまでにお時間をいただくこともございます</li>
                                    <li>・ お客様からお預かりした個人情報を含む情報は全てを適切に処理し管理いたします</li>
                                    <li>・ 上記情報は目的外に使用することは無く部外者に提供する事はありません</li>
                                </ul>
                                <div className="row mt-3">
                                    {this.renderSubmitButton("recruitForm-btn bg-orange mt-3", "確認する")}
                                </div>
                                {this.renderErrorForm()}
                            </form>
                        </div>
                    </div>
                </div>

            </React.Fragment >
        );
    }
}

export default RecruitForm;

